/**
 * Created by lxhfight on 2018/4/8.
 * Email:
 * Description:
 *   管理訊息的全局數據
 */

import messageApi from './../apis/message'
import momentApi from '../apis/moments'

const state = {
  msgStatus: {
    conversations: '',
    messages: ''
  },
  currentTabIndex: 0, // 表示當前所在
  subTabIndex: [0, 0, 0],
  sysMessage: [
    {
      type: '',
      data: [],
      currentPage: 1,
      lastPage: 1,
      total: -1,
      loading: false,
      unreadCount: 0
    },
    {
      type: 'comment',
      data: [],
      currentPage: 1,
      lastPage: 1,
      total: -1,
      loading: false,
      unreadCount: 0
    },
    {
      type: 'moment',
      data: [],
      currentPage: 1,
      lastPage: 1,
      total: -1,
      loading: false,
      unreadCount: 0
    }
  ],
  envMessage: [
    {
      type: '',
      data: [],
      currentPage: 1,
      lastPage: 1,
      total: -1,
      loading: false,
      unreadCount: 0
    },
    {
      type: 'give',
      data: [],
      currentPage: 1,
      lastPage: 1,
      total: -1,
      loading: false,
      unreadCount: 0
    },
    {
      type: 'receive',
      data: [],
      currentPage: 1,
      lastPage: 1,
      total: -1,
      loading: false,
      unreadCount: 0
    },
    {
      type: 'direct_message',
      data: [],
      currentPage: 1,
      lastPage: 1,
      total: -1,
      loading: false,
      unreadCount: 0
    }
  ],
  dynamicMessage: [
    {
      type: '',
      data: [],
      currentPage: 1,
      lastPage: 1,
      total: -1,
      loading: false,
      unreadCount: 0
    }
  ],
  unreadMessageCounts: {
    // notifyCount: {
    //   all: 0,
    //   comment: 0,
    //   moment: 0
    // },
    // conversation: {
    //   all: 0,
    //   give: 0,
    //   receive: 0,
    //   direct: 0
    // }
    notify_count: {},
    conversation_count: {}
  },
  topMessages: []
}

const actions = {
  getEnvMessageList ({ commit, state }, {page, type}) {
    return messageApi.getEnvMessageList(
      page,
      type
    )
  },
  getSysMessageList ({ commit, state }, {page, type}) {
    return messageApi.getSysMessageList(
      page,
      type
    )
  },
  getMomentNotifyList ({ commit, state }, {page}) {
    return momentApi.getMomentNotify(page)
  },
  getDynamicMessageList (store, { page }) {
    return messageApi.getDynamicMessage(page)
  },
  getChatId ({ commit, state }, {type, thingId, directUserId, cb}) {
    messageApi.getChatId(
      type,
      thingId,
      directUserId,
      (data) => cb(data)
    )
  },
  readMsg ({ commit, state }, {type, msgId, cb = null} = {}) {
    messageApi.readMsg(
      msgId,
      (data) => {
        commit('setReadMsg', {type, msgId})
        if (cb) {
          cb(data)
        }
      }
    )
  },
  getMessageStatus ({commit, state}, {cb = null} = {}) {
    messageApi.getMessageStatus(
      (data) => {
        commit('setMessageStatus', {data})
        if (cb) {
          cb(data)
        }
      }
    )
  },
  getChatByDirectId ({commit, state}, {id, cb = null} = {}) {
    messageApi.getChattingDetail(
      id,
      (data) => {
        if (cb) {
          cb(data)
        }
      }
    )
  },
  readAllMsg ({commit, state}, {type, cb = null} = {}) {
    messageApi.readAllMsg(
      type,
      (data) => {
        if (cb) {
          cb(data)
        }
      }
    )
  },
  getUnreadMessageCount ({commit}) {
    messageApi.getUnreadMessageCount()
      .then(res => {
        commit('setUnreadMessageCount', res)
      })
  },
  getTopMessages ({ commit }) {
    return messageApi.getTopMessages()
      .then((res) => {
        commit('setTopMessages', res.data)
        return res.data
      })
  }
}

const mutations = {
  resetMessageList (state) {
    state.currentTabIndex = 0
    state.subTabIndex = [0, 0]
    state.sysMessage = [
      {
        type: '',
        data: [],
        currentPage: 1,
        lastPage: 1,
        total: -1,
        loading: false
      },
      {
        type: 'comment',
        data: [],
        currentPage: 1,
        lastPage: 1,
        total: -1,
        loading: false
      },
      {
        type: 'moment',
        data: [],
        currentPage: 1,
        lastPage: 1,
        total: -1,
        loading: false
      }
    ]
    state.envMessage = [
      {
        type: '',
        data: [],
        currentPage: 1,
        lastPage: 1,
        total: -1,
        loading: false
      },
      {
        type: 'give',
        data: [],
        currentPage: 1,
        lastPage: 1,
        total: -1,
        loading: false
      },
      {
        type: 'receive',
        data: [],
        currentPage: 1,
        lastPage: 1,
        total: -1,
        loading: false
      },
      {
        type: 'direct_message',
        data: [],
        currentPage: 1,
        lastPage: 1,
        total: -1,
        loading: false
      }
    ]
  },
  setCurrent (state, current) {
    state.currentTabIndex = current
  },
  setSubIndex (state, subIndex) {
    let newSubTabIndex = [...state.subTabIndex]
    newSubTabIndex[state.currentTabIndex] = subIndex
    state.subTabIndex = newSubTabIndex
  },
  setMessageLoading (state, {loading, index, subIndex}) {
    let type = ['sysMessage', 'envMessage', 'dynamicMessage'][index]
    let newMessages = Object.assign([], state[type])
    newMessages[subIndex] = {
      ...newMessages[subIndex],
      loading: true
    }
    state[type] = newMessages
  },
  setMessageData (state, {currentPage, lastPage, total, data, index, subIndex, topMessages}) {
    if (topMessages && topMessages.length) {
      state.topMessages = topMessages
    }

    let type = ['sysMessage', 'envMessage', 'dynamicMessage'][index]

    if (type === 'sysMessage' && subIndex === 0) {
      data = data.filter(item => topMessages.every(topMessage => topMessage.id !== item.id))
      if (topMessages.length || currentPage === 1) {
        data.unshift(...topMessages)
      }
    }

    let newMessages = Object.assign([], state[type])
    newMessages[subIndex] = {
      ...newMessages[subIndex],
      currentPage: currentPage + 1,
      lastPage,
      total,
      loading: false,
      data: currentPage === 1 ? data : newMessages[subIndex].data.concat(data)
    }

    state[type] = newMessages
  },
  setReadMsg (state, {type, msgId}) {
    for (let i = 0; i < state[type].length; ++i) {
      if (state[type][i].type === 'moment') continue
      let match = state[type][i].data.find(item => item.id === msgId)
      if (match) {
        match.is_read = 1
      }
    }
    state[type] = [...state[type]]
  },
  setMessageStatus (state, {data}) {
    if (data) {
      state.msgStatus = {
        ...state.msgStatus,
        conversations: data.conversation,
        messages: data.message
      }
    }
  },
  setMessageAllRead (state, {type}) {
    const msgType =
      type === 'messages' ? 'sysMessage' : type === 'conversations' ? 'envMessage' : type === 'dynamics' ? 'dynamicMessage' : null
    if (!msgType) return
    for (let i = 0; i < state[msgType].length; ++i) {
      if (msgType === 'sysMessage' && state[msgType][i].type === 'moment') continue
      state[msgType][i].data = state[msgType][i].data.map(item => {
        return {
          ...item,
          is_read: 1
        }
      })
    }
    state[msgType] = [...state[msgType]]
    const nextStatus = {...state.msgStatus}
    if (type === 'messages' || type === 'conversations') {
      nextStatus[type] = false
    }
    state.msgStatus = nextStatus
  },
  setUnreadMessageCount (state, payload) {
    state.unreadMessageCounts = payload
    for (let item of state.sysMessage) {
      item.unreadCount = payload.notify_count[`${item.type || 'all'}`]
    }

    for (let item of state.envMessage) {
      if (item.type === 'direct_message') {
        item.unreadCount = payload.conversation_count['direct']
      } else {
        item.unreadCount = payload.conversation_count[`${item.type || 'all'}`]
      }
    }
  },
  setMomentNotifyUnreadCount (state, count) {
    for (let item of state.sysMessage) {
      if (item.type === 'moment') {
        item.unreadCount = count
      }
    }
  },
  setTopMessages (state, data) {
    state.topMessages = data
  },
  setMessageReadByOpeningConversation (state, conversationId) {
    for (let item of state.sysMessage[0].data) {
      if (item.conversation_id === conversationId && !item.is_read) {
        item.is_read = 1
        state.sysMessage[0].unreadCount -= 1
        if (state.sysMessage[0].unreadCount < 0) {
          state.sysMessage[0].unreadCount = 0
        }
      }
    }

    for (let msgData of state.envMessage) {
      if (['', 'give', 'receive'].includes(msgData.type)) {
        for (let item of msgData.data) {
          if (item.id === conversationId && !item.is_read) {
            item.is_read = 1
            msgData.unreadCount -= 1
            if (msgData.unreadCount < 0) {
              msgData.unreadCount = 0
            }
          }
        }
      }
    }
  }
}

export default{
  state,
  actions,
  mutations
}
